import React from 'react'

export const SenceIcon = () => (
  <svg width={60} height={48}>
    <g fill="none" fillRule="evenodd" transform="translate(4 1)">
      <circle cx="21.642" cy="23.167" r="21.642" fill="#F9DFDF" />
      <path
        stroke="gray"
        strokeLinecap="round"
        strokeWidth={2}
        d="M29.273 40.424H3.05a1.525 1.525 0 0 1-1.526-1.526V12.203c0-.842.683-1.525 1.526-1.525h4.477m30.976 0h2.683c.843 0 1.526.683 1.526 1.525v13.73M38.294 8.39v9.477"
      />
      <path
        fill="gray"
        d="M38.136 19.83c1.053 0 1.906.854 1.906 1.907v4.195H36.23v-4.195c0-1.053.854-1.906 1.907-1.906z"
      />
      <path
        stroke="gray"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10.678 9.559v3.553l11.941 5.193 12.466-4.973V9.287"
      />
      <path
        stroke="gray"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M22.5 0L3.432 6.517 22.5 13.729l19.068-7.212z"
      />
      <path
        stroke="gray"
        strokeLinecap="round"
        strokeWidth={2}
        d="M6.864 25.55H22.5"
      />
      <circle cx="8.008" cy="20.212" r="1.907" fill="gray" />
      <path
        stroke="gray"
        strokeLinecap="round"
        strokeWidth={2}
        d="M6.864 30.7h24.407"
      />
      <path
        fill="#C00"
        fillRule="nonzero"
        d="M46.286 29.818c0-.49-.343-.818-.857-.818H38.57c-.514 0-.857.327-.857.818v3.273H36V47h12V33.09h-1.714v-3.272z"
      />
      <path
        fill="#C00"
        fillRule="nonzero"
        d="M39.429 30.636h5.142v2.455H39.43z"
      />
      <path
        fill="#C00"
        d="M51 33h-2v14h2c.6 0 1-.33 1-.824V33.824c0-.495-.4-.824-1-.824zm-19 .824v12.352c0 .495.4.824 1 .824h2V33h-2c-.6 0-1 .33-1 .824z"
      />
    </g>
  </svg>
)
